import React, { FC } from "react";
import clsx from "clsx";

import { useTranslation } from "lib/i18n/use-translation";

import styles from "../december-doors.module.scss";

interface DoorsProgressProps {
  opened: number;
  total: number;
  /** Doors whose day has passed but which are still shut. */
  stillToOpen: number;
}

// Counts what the learner has done, never what is left of a quota: the bar
// is decoration and the copy carries the meaning.
const DoorsProgress: FC<DoorsProgressProps> = ({
  opened,
  total,
  stillToOpen,
}) => {
  const { t } = useTranslation(["decemberDoors"]);

  return (
    <div className={styles.progress} data-testid="doors-progress">
      <p className={styles["progress-label"]}>
        {opened === 0
          ? t("decemberDoors:counter.none")
          : t("decemberDoors:counter.opened", { count: opened })}
        {stillToOpen > 0 && (
          <>
            {" "}
            <span className={styles["progress-catch-up"]}>
              {t("decemberDoors:counter.stillToOpen", { count: stillToOpen })}
            </span>
          </>
        )}
      </p>
      <div className={styles["progress-bar"]} aria-hidden>
        {Array.from({ length: total }, (_, index) => (
          <span
            key={index}
            className={clsx(
              styles["progress-segment"],
              index < opened && styles["progress-segment-filled"]
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default DoorsProgress;
